<script lang="ts">
	import classNames from 'classnames';
	import { twMerge } from 'tailwind-merge';
	import { CardTag } from '../CardTag';
	import { TagText } from '../CardTag/TagText';
	import { GlobalRoutes } from '#lib/features/navigation/constants/global-routes.js';
	import { NewsMixpanelEvents } from '#lib/features/news/constants/mixpanel-events.js';
	import { ArticleSearchCategory } from '#lib/websites/news/constants/categories.js';
	import { getSearchVariables } from '#lib/websites/news/pages/NewsHomePage/utils/getSearchVariables/getSearchVariables.js';
	import { isCategoryActive } from '#lib/websites/news/pages/NewsHomePage/utils/isCategoryActive/isCategoryActive.js';
	import { page } from '$app/state';
	import { ShoutoutIcon } from '$global/assets/icons/ShoutoutIcon';
	import { capitalizeFirstLetters } from '$global/utils/capitalizeFirstLetters';
	import { track } from '$global/utils/track';

	let { dataCy, category, onClick = undefined, ...rest }: Props = $props();

	interface Props {
		dataCy: string;
		category: string;
		onClick?: (() => void) | undefined;
		class?: string;
	}

	let showGlobalNav = $derived(page.data.showGlobalNav ?? true);
	let searchParams = $derived(page.url.searchParams);
	let variables = $derived(getSearchVariables(searchParams));
	let path = $derived(page.url.href.split(page.url.origin)[1]);

	let getIsCategoryActive = $derived((searchCategory: string) =>
		isCategoryActive({
			searchCategory,
			variables,
			path,
		})
	);
</script>

<CardTag
	showNewVersion={false}
	onclick={() => {
		if (onClick) {
			onClick();
		}
		track(NewsMixpanelEvents.Search, { category });
	}}
	href={`${GlobalRoutes.NewsHome}${
		showGlobalNav
			? `?category=${category === 'nft' ? 'NFT' : category}`
			: `?global_nav=0&category=${category === 'nft' ? 'NFT' : category}`
	}`}
	class={twMerge(
		classNames(
			'border-blue-600',
			getIsCategoryActive(category) ? 'bg-blue-600' : 'bg-transparent'
		),
		rest.class
	)}
	{dataCy}
>
	{#if category === ArticleSearchCategory.shoutouts}
		<ShoutoutIcon
			color={getIsCategoryActive(category) ? 'gray-0' : 'blue-600'}
			class="h-4 w-4"
		/>
	{:else}
		<TagText
			color="blue"
			isActive={getIsCategoryActive(category)}
			label={category === 'nft' ? 'NFT' : capitalizeFirstLetters(category)}
		/>
	{/if}
</CardTag>
